/**
 * Margine verticale (padding top/bottom) selezionabile per blocco da admin
 * — utile per accorpare due blocchi senza il grande spazio bianco tra loro,
 * o azzerarlo del tutto quando un blocco deve stare al minimo ingombro
 * (es. subito sopra/sotto un altro blocco a tutto schermo).
 */
export const SPACING_OPTIONS = [
  { value: 'normal', label: 'Normale' },
  { value: 'compact', label: 'Ridotto' },
  { value: 'none', label: 'Nessuno (minimo ingombro)' },
];

export function spacingClass(spacing = 'normal') {
  if (spacing === 'none') return 'py-0';
  if (spacing === 'compact') return 'py-10 md:py-14';
  return 'py-24 md:py-32';
}
